'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _Dock = require('./Dock');

var _Dock2 = _interopRequireDefault(_Dock);

exports['default'] = _Dock2['default'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dock/lib/index.js
 ** module id = 681
 ** module chunks = 0
 **/